import { Menu } from 'antd'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ShieldCheck } from '@phosphor-icons/react'
import {
    BridgeIcon,
    BuildingsIcon,
    ChartLineIcon,
    CylinderIcon,
    FlagIcon,
    GearIcon,
    GraduationCapIcon,
    HouseIcon,
    PackageIcon,
    PaperPlaneTiltIcon,
    SignOutIcon,
    UserIcon,
    EscalatorUpIcon,
    BuildingOfficeIcon,
    NoteIcon,
    EnvelopeIcon,
    HandbagSimpleIcon
} from '@phosphor-icons/react'

interface NavigationMenuProps {
    onNavigate?: () => void
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({ onNavigate }) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const onClick = (e: any) => {
        navigate(e.key)
        onNavigate?.()
    }

    return (
        <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[pathname]}
            items={[
                {
                    key: '/',
                    icon: <HouseIcon />,
                    label: 'Dashboard',
                    onClick
                },
                {
                    key: '/users',
                    icon: <UserIcon />,
                    label: 'Users',
                    onClick
                },
                {
                    key: '/schools',
                    icon: <BuildingOfficeIcon />,
                    label: 'Schools',
                    onClick
                },
                {
                    key: '/subscriptions',
                    icon: <NoteIcon />,
                    label: 'Subscriptions',
                    onClick
                },
                {
                    key: '/publishers',
                    icon: <BuildingsIcon />,
                    label: 'Publishers',
                    onClick
                },
                {
                    key: '/products',
                    icon: <PackageIcon />,
                    label: 'Products',
                    onClick
                },
                {
                    key: '/coupons',
                    icon: <HandbagSimpleIcon />,
                    label: 'Coupons',
                    onClick
                },
                {
                    key: '/reports',
                    icon: <ChartLineIcon />,
                    label: 'Reports',
                    onClick
                },
                {
                    key: '/curriculums',
                    icon: <CylinderIcon />,
                    label: 'Curriculum',
                    onClick
                },
                {
                    key: '/year-levels',
                    icon: <GraduationCapIcon />,
                    label: 'Year Level',
                    onClick
                },
                {
                    key: '/curriculum-builder',
                    icon: <BridgeIcon />,
                    label: 'Curriculum Builder',
                    onClick
                },
                {
                    key: '/bundles',
                    icon: <PaperPlaneTiltIcon />,
                    label: 'Bundles',
                    onClick
                },
                {
                    key: '/invitees',
                    icon: <EscalatorUpIcon />,
                    label: 'Invites',
                    onClick
                },
                {
                    key: '/email-messages',
                    icon: <EnvelopeIcon />,
                    label: 'Emails',
                    onClick
                },
                {
                    key: '/feature-flags',
                    icon: <FlagIcon />,
                    label: 'Feature Flags',
                    onClick
                },
                {
                    key: '/settings',
                    icon: <GearIcon />,
                    label: 'Settings',
                    onClick
                },
                {
                    key: '/mfa',
                    icon: <ShieldCheck />,
                    label: 'MFA',
                    onClick
                },
                {
                    key: '#logout',
                    icon: <SignOutIcon />,
                    label: 'Sign Out',
                    onClick: async () => {
                        navigate('/logout')
                        onNavigate?.()
                    }
                }
            ]}
        />
    )
}
